export const INIT_AUTHENTICATION = 'AUTHENTICATION::INIT_AUTHENTICATION';
export const RESPONSE_AUTHENTICATION = 'AUTHENTICATION::RESPONSE_AUTHENTICATION';
export const ERROR_AUTHENTICATION = 'AUTHENTICATION::ERROR_AUTHENTICATION';
export const RESET_AUTHENTICATION = 'AUTHENTICATION::RESET_AUTHENTICATION';
